export function hasKey<O extends object>(obj: O, key: string | number | symbol): key is keyof O {
  return key in obj;
}
